const Fetcher = require('od-modules/utils/fetcher');

module.exports = {};

var DEFAULT_SESSION_TIME = 17 * 60 * 1000;
var refreshInterval;
var execution = [];

var requestSuccessRefresh = function() {
    Odigeo.Utils.sessionTimer.resetTimeoutCounter(refreshInterval + 60000);
};
const getUrlParams = (bookingId) => `${Odigeo.Settings.property('serviceUrlFormatter')('refreshSession')}?${$.param({bookingId})}`;

const requestErrorRefresh = (page) => {
    Odigeo.UIElements.showSessionExpiredError('alert', true);
    clearInterval(execution[page]);
};

var _getRefresh = (bookingId, page, counter) => Fetcher.get(getUrlParams(Odigeo.Utils.trim(bookingId))).json()
    .then((errorList) => {
        if (errorList && errorList.length) {
            requestErrorRefresh(page, counter, errorList);
        } else {
            requestSuccessRefresh();
        }
    });

module.exports.refreshSession = function(bookingId, page) {
    var counter = 0;
    refreshInterval = DEFAULT_SESSION_TIME;
    if (!Odigeo._.isUndefined(execution[page])) {
        clearInterval(execution[page]);
    }
    Odigeo.Utils.sessionTimer.resetTimeoutCounter(refreshInterval + 60000);
    execution[page] = setInterval(function() {
        if (Odigeo.Session.get('page') === page && counter < 3) {
            counter = counter + 1;
            _getRefresh(bookingId, page, counter);
        } else {
            clearInterval(execution[page]);
        }
    }, refreshInterval);
};
